module.exports = __webpack_public_path__ + "static/media/frontVideo.6f17119f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/frontVideo.mp4
// module id = 1636
// module chunks = 0